export const getBrowser = () => {
  const ua = navigator.userAgent
  if (/chrome|crios|crmo/i.test(ua) && /google/i.test(navigator.vendor)) return 'chrome'
  if (/safari/i.test(ua) && /apple/i.test(navigator.vendor)) return 'safari'
  return 'other'
}
